<template>
  <div class="item-content">
    <div class="dropdown">
      <div v-if="valueType === 'string'">
        <input v-if="selectedItem.length === 0" ref="dropdowninput" v-model="inputValue" class="dropdown-input" type="text" :placeholder="placeholderValue" autocomplete="my-field-name"/>
        <input v-else :value="selectedItem" class="dropdown-selected" type="text" @click="resetSelection"/>
        <div v-if="inputValue && !selectedItem" v-show="inputValue" class="dropdown-list" v-bind:style="{'max-height': dropdownMaxHeight}">
          <div @click="selectItem(item)" v-show="itemVisible(item)" v-for="item in itemList" :key="item" class="dropdown-item">
            {{ item }}
          </div>
        </div>
      </div>
      <div v-else-if="valueType === 'object'"> <!-- For selector with object as component value -->
        <input v-if="selectedItem.length === 0" ref="dropdowninput" v-model="inputValueObj" class="dropdown-input form-control inputAccordionForm" type="text" :placeholder="placeholderValue" autocomplete="my-field-name"/>
        <input v-else :value="inputValueObj" class="dropdown-selected form-control inputAccordionForm" type="text" @click="resetSelection"/>
        <div v-if="inputValueObj && !selectedItem" v-show="inputValueObj" class="dropdown-list" v-bind:style="{'max-height': dropdownMaxHeight}">
          <div @click="selectItem(item)" v-show="itemVisible(item)" v-for="item in itemList" :key="item[objectKey]" class="dropdown-item">
            <div>
              <label class="">{{ item[valueKey] }}</label>
              <br/>
              <label class="">{{ item[subTextKey] }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'formDropdownInput',
  props: {
    placeholderValue: {
      type: String,
      default: 'Search in list'
    },
    itemList: {
      type: Array,
      required: true
    },
    value: {
      default: ''
    },
    valueKey: {
      type: String
    },
    objectKey: {
      type: String
    },
    subTextKey: {
      type: String
    },
    dropdownMaxHeight: {
      type: String,
      default: '84px'
    }
  },
  data: function () {
    return {
      selectedItem: '',
      inputValueObj: ''
    }
  },
  mounted () {
  },
  methods: {
    resetSelection () {
      this.selectedItem = ''
      this.$nextTick(() => this.$refs.dropdowninput.focus())
      if (this.valueType === 'object') {
        this.inputValueObj = ''
        this.$emit('input', {})
      } else {
        this.inputValue = ''
      }
    },
    selectItem (selectedItem) {
      this.selectedItem = selectedItem
      if (this.valueType === 'object') {
        this.inputValueObj = selectedItem[this.valueKey]
        this.$emit('input', selectedItem)
      } else {
        this.inputValue = selectedItem
      }
    },
    itemVisible (item) {
      let currentName = this.valueType === 'object' ? item[this.valueKey].toLowerCase() : item.toLowerCase()
      let currentInput = this.valueType === 'object' ? this.inputValueObj.toLowerCase() : this.inputValue.toLowerCase()
      if (currentName === currentInput) {
        return false
      }
      return currentName.includes(currentInput)
    }
  },
  computed: {
    valueType: {
      get () {
        if (typeof this.value === 'object') {
          return Array.isArray(this.value) ? 'array' : 'object'
        }
        return 'string'
      }
    },
    inputValue: {
      get () {
        return this.valueType === 'object' ? this.value[this.valueKey] : this.value
      },
      set (val) {
        if (this.valueType === 'string') {
          this.$emit('input', val)
        }
      }
    }
  }
}
</script>

<style scoped>
.dropdown{
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0;
}
.dropdown-input, .dropdown-selected{
  width: 100%;
  outline: none;
}
.dropdown-input:focus, .dropdown-selected:hover{
  background: #fff;
  border-color: #e2e8f0;
}
.dropdown-input::placeholder{
  opacity: 0.7;
  color: #333;
}
.dropdown-selected{
  cursor: pointer;
}
.dropdown-list{
  position: absolute;
  z-index: 30000;
  width: 100%;
  margin-top: 4px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}
.dropdown-item{
  display: flex;
  width: 100%;
  padding: 11px 16px;
  cursor: pointer;
}
.dropdown-item:hover{
  background: #edf2f7;
}
.dropdown-item-flag{
  max-width: 24px;
  max-height: 18px;
  margin: auto 12px auto 0px;
}
</style>



// WEBPACK FOOTER //
// formDropdownInput.vue?860d92c0